import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative h-[85vh] min-h-[600px] w-full flex items-end pb-20 pt-32" data-id="element-178">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-179">
        <img src="https://cdn.magicpatterns.com/uploads/9SYf85LoRMFrPstrPp9L4P/bannerLander3.png" alt="Mujer vistiendo un blazer elegante de Terracotta Atelier" className="w-full h-full object-cover object-center" data-id="element-180" />
        {/* Gradient Overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-t from-charcoal/90 via-charcoal/40 to-transparent" data-id="element-181"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-182">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="max-w-3xl" data-id="element-183">
          <h1 className="text-4xl md:text-5xl lg:text-7xl font-display font-medium text-cream-50 leading-tight mb-6" data-id="element-184">
            Deja de comprar ropa.
            <br data-id="element-185" />
            <span className="italic text-cream-200" data-id="element-186">
              Empieza a construir imagen.
            </span>
          </h1>

          <p className="text-lg md:text-xl text-cream-100 mb-10 max-w-2xl font-light leading-relaxed" data-id="element-187">
            Para la mujer caleña que sabe exactamente lo que vale — y ya es hora
            de que su imagen lo demuestre.
          </p>

          <a href="https://wa.me/573160551859?text=Quiero%20construir%20mi%20imagen" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 text-base font-medium bg-olive-500 text-cream-50 hover:bg-olive-600 transition-colors duration-300" data-id="element-188">
            Escríbenos al WhatsApp
          </a>
        </motion.div>
      </div>
    </section>;
}